import { render, staticRenderFns } from "./HomeCards.vue?vue&type=template&id=155dc97a&"
import script from "./HomeCards.vue?vue&type=script&lang=js&"
export * from "./HomeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports